<script>
    import { browser } from '$app/environment';
    import { onNavigate } from '$app/navigation';
    import { cookie_consent_marketing } from './stores/globals';
    import { get } from 'svelte/store';

    let is_installed = false;
    let tried_to_install = false;
    let consent_unsubscribe = null;

    // Keep Meta off classroom-only and student-facing school routes.
    const blocked_path_patterns = [
        /^\/join\/?$/,
        /^\/classrooms?(?:\/|$)/,
        /^\/my-classrooms(?:\/|$)/,
        /^\/my-school(?:\/|$)/
    ];

    const is_blocked_path = (pathname = '') => {
        return blocked_path_patterns.some((pattern) => pattern.test(pathname));
    };

    const install_facebook = (pathname) => {
        if (!browser) return;

        if (!pathname) pathname = window.location.pathname;

        if (navigator?.['globalPrivacyControl'] === true) return;

        if (is_blocked_path(pathname)) return;

        if (get(cookie_consent_marketing)) {
            if (is_installed || tried_to_install) return;
            tried_to_install = true;
            performInstall();
        } else {
            setupConsentListener();
        }
    }

    const performInstall = () => {

        // console.log('Installing Facebook Pixel')
        // @ts-ignore
        !function(f,b,e,v,n,t,s){
            if (f.fbq) return;
            
            n=f.fbq=function(){
                n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments)
            };
            if(!f._fbq) f._fbq=n; 
            n.push=n;
            n.loaded=!0;
            n.version='2.0';
            n.queue=[];
            t=b.createElement(e);
            t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)
        }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
        window.fbq('init', '1032062254574213');
        window.fbq('track', 'PageView');
        is_installed = true;
    }

    const setupConsentListener = () => {
        if (consent_unsubscribe) return;

        consent_unsubscribe = cookie_consent_marketing.subscribe((value) => {
            if (
                value &&
                !is_installed &&
                !tried_to_install
            ) {
                // console.log('Cookie consent granted for marketing');
                install_facebook();
                if (consent_unsubscribe) {
                    consent_unsubscribe();
                    consent_unsubscribe = null;
                }
            }
        });
    }

    onNavigate((navigation) => {
        navigation.complete.then(() => {
            if (!browser) return;

            const pathname =
                navigation.to?.url?.pathname || window.location.pathname;

            if (navigator?.['globalPrivacyControl'] === true) return;

            if (is_blocked_path(pathname)) return;

            if (!is_installed) {
                install_facebook(pathname);
                return;
            }

            window.fbq('track', 'PageView');
        });
    });

    install_facebook();
</script>
